<template>
  <div :class="{'container-manage': !isMenuMiniSize, 'container-manage-thin-menu': isMenuMiniSize}">
    <!-- ヘッダー -->
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Data</b></p>
        <!-- 応募者管理画面へのリンク -->
        <router-link 
          to="/client/manage" 
          style="margin-left: 25px; font-size:16px; color: #666; text-decoration: none; cursor: pointer; transition: all 0.2s; margin-top: 8px;"
          onmouseover="this.style.color='#333'; this.style.textDecoration='underline'" 
          onmouseout="this.style.color='#666'; this.style.textDecoration='none'"
        >
          応募者管理画面
        </router-link>
        <span style="margin: 0 10px; color: #ccc; margin-top: 8px;">/</span>
        <p style="font-size:16px; color: #666; margin-top: 8px;">レポーティング</p>
        <span style="margin: 0 10px; color: #ccc; margin-top: 8px;">/</span>
        <router-link 
          to="/client/robot-performance" 
          style="font-size:16px; color: #666; text-decoration: none; cursor: pointer; transition: all 0.2s; margin-top: 8px;"
          onmouseover="this.style.color='#333'; this.style.textDecoration='underline'" 
          onmouseout="this.style.color='#666'; this.style.textDecoration='none'"
        >
          ロボの稼働状況
        </router-link>
      </div>
      <!-- 送信履歴ボタンは削除 -->
    </div>
    
    <!-- レポート画面 -->
    <ReportView
      ref="reportView"
      :user="user"
      :isMenuMiniSize="isMenuMiniSize"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ReportView from '@/views/DashBoard/Report/ReportView'

export default {
  name: 'ReportMainView',
  components: {
    ReportView
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState("setting", ["isMenuMiniSize"])
  },
  mounted() {
    // スーパーユーザーまたは管理権限を持つユーザー以外はリダイレクト
    if (!this.user.isAgent && this.user.permission !== 0) {
      this.$router.push('/client/manage')
      this.$toast.open({
        message: 'この機能は管理権限を持つユーザーのみ利用可能です',
        type: 'is-warning',
        duration: 3000
      })
    }
  }
}
</script>

<style scoped>
.container-manage {
  position: absolute;
  width: calc(100% - 200px);
  left: 200px;
  top: 0;
  height: 100vh;
  background: #F5F5F5;
  overflow: hidden;
}

.container-manage-thin-menu {
  position: absolute;
  width: calc(100% - 50px);
  left: 50px;
  top: 0;
  height: 100vh;
  background: #F5F5F5;
  overflow: hidden;
}

.header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  padding: 0 16px;
  border-bottom: solid 1px #E5E5E5;
}

.header-menu {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Report/ReportMainView.vue